export default {"src":"/_next/static/media/hm-logo-white.443147f7.svg","height":118,"width":216,"blurWidth":0,"blurHeight":0};